<template>
    <div class="touchpoint-map-hint">
        <span class="touchpoint-map-hint__icon"></span> <slot></slot>
    </div>
</template>
<script>
export default {
    name: 'TouchpointMapHint',
}
</script>